/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfoLink_shipmentQuote$ref = any;
type PdpSharedShippingInfo_shipmentQuote$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpSharedBlurbShipping_shipmentQuote$ref = any;
export type PdpSharedBlurbShipping_shipmentQuote = {
    readonly isCustom: boolean | null;
    readonly isNew: boolean | null;
    readonly status: string | null;
    readonly complimentaryShipping: unknown | null;
    readonly subTotalAmount: {
        readonly amount: number | null;
    } | null;
    readonly buyerSubTotalAmount: {
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
    readonly serviceMethod: {
        readonly isWhiteGlove: boolean | null;
    } | null;
    readonly " $fragmentRefs": PdpSharedShippingInfoLink_shipmentQuote$ref & PdpSharedShippingInfo_shipmentQuote$ref;
    readonly " $refType": PdpSharedBlurbShipping_shipmentQuote$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "PdpSharedBlurbShipping_shipmentQuote",
        "type": "ShipmentQuote",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isCustom",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isNew",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "complimentaryShipping",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "subTotalAmount",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "buyerSubTotalAmount",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "convertedAmountList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "currency",
                                "args": null,
                                "storageKey": null
                            },
                            (v0 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "serviceMethod",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentServiceMethod",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isWhiteGlove",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpSharedShippingInfoLink_shipmentQuote",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpSharedShippingInfo_shipmentQuote",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = 'cf3eb0293a5540ec355e36191ec4ba73';
export default node;
